import React from "react";
import PropTypes from "prop-types";
import ActiveFormStore from "data/ActiveFormStore";
import { lastBlurredValidation } from "data/selectors/records";
import TableStore from "data/TableStore";
import { isOk } from "jsmodel/utils";
import useFluxStore from "@armus/use-flux-store";

export class ValidationBar extends React.Component {

    render() {
        const {
            code,
            message,
        } = this.props;
        return (
          <div className="row">
              <div className="col-md-12 msg" title="status bar">
                  {message != null && ! isOk(code) && message}
              </div>
          </div>
        );
    }

}

ValidationBar.propTypes = {
    code: PropTypes.number,
    message: PropTypes.string,
};

export const FluxValidationBar = props => {
    const {fluxContext} = props;
    const state = useFluxStore(() =>
        lastBlurredValidation(
            fluxContext,
            TableStore,
            ActiveFormStore,
        ), [
        TableStore,
        ActiveFormStore,
    ], [fluxContext]);
    return <ValidationBar {...state} />;
};

FluxValidationBar.propTypes = {
    fluxContext: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/ValidationBar.js